import { queryOptions } from '@tanstack/react-query'

import { axios } from '@/api/common.ts'

import {
  MachineCodeSelectOption,
  MachineSelectGroupOptions,
  MachineSelectOptions,
  MachineSelectOptionsSchema,
} from '@/api/options/machine.schema.ts'

export const fetchMachineSelectOptions = () =>
  queryOptions({
    queryKey: ['machines', 'all'],
    queryFn: () => fetchMachineAll(),
  })

export async function fetchMachineAll(): Promise<MachineSelectOptions> {
  const response = await axios.get('/api/masterdata/options/machine')
  return MachineSelectOptionsSchema.parse(response.data)
}

// Make machine select options' value the same as label (machine code)
export function convertToMachineCodeSelectOptions(
  options: MachineSelectOptions
): MachineCodeSelectOption[] {
  const result = options.map((o) => ({
    id: o.id,
    code: o.code,
    capacityPerHour: o.capacityPerHour,
    runningPrefix: o.runningPrefix,
    label: o.code,
    value: o.code,
  }))

  return result
}

export function convertToSelectGroupOptions(
  options: MachineSelectOptions
): MachineSelectGroupOptions {
  const groups: MachineSelectGroupOptions = []
  options.forEach((o) => {
    const group = groups.find((g) => g.group === o.group)
    // Recreate an item in group from original item
    // This item cannot have property 'group' again,
    // otherwise Mantine 'Select' will throw error
    const item = {
      id: o.id,
      code: o.code,
      capacityPerHour: o.capacityPerHour,
      label: o.code,
      value: o.id.toString(),
    }

    if (!group) {
      groups.push({
        group: o.group,
        items: [item],
      })
    } else {
      group.items.push(item)
    }
  })
  return groups
}
